var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"services"},[_c('div',{staticClass:"services-container main"},[_c('div',{staticClass:"services-content"},_vm._l((_vm.$locale['object']['services-cards']),function(card,key,idx){return _c('ServicesCard',{key:idx,attrs:{"card":card,"isOdd":idx % 2 !== 0}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }